import React from 'react';

export default function Team() {
    const handleBookNow = (offerTitle) => {
        const message = encodeURIComponent(`مرحباً، أود حجز: ${offerTitle}`);
        window.open(`https://wa.me/966556838300?text=${message}`, '_blank');
    };

    const offers = [
        {
            id: 1,
            title: "عرض بالي الذهبي",
            description: "تجربة استرخاء فاخرة متكاملة",
            originalPrice: "299 ريال",
            discountPrice: "199 ريال",
            icon: "💆‍♂️",
            features: [
                "ساعة مساج (تايلندي/سويدي/استرخائي)",
                "حمام مغربي كامل مع حمام بخار",
                "إزالة الجلد الميت وصنفرة الجسم",
                "حمام زيت للشعر",
                "تنظيف بشرة بالليزر",
                "صنفرة للوجه + 2 قناع + لصقة أنف",
                "تقفيل مسامات بالليزر"
            ]
        },
        {
            id: 2,
            title: "الباقة البلاتينية",
            description: "عناية شاملة بالجسم واليدين والقدمين",
            originalPrice: "329 ريال",
            discountPrice: "239 ريال",
            icon: "✨",
            features: [
                "40 دقيقة مساج (تايلندي/سويدي/استرخائي)",
                "حمام مغربي كامل مع حمام بخار",
                "صنفرة للجسم وحمام زيت",
                "بديكير لليدين (تنظيف وترطيب)",
                "بديكير للأقدام (تقشير وعلاج التشققات)",
                "عناية متكاملة بالبشرة"
            ]
        },
        {
            id: 3,
            title: "عرض العرسان",
            description: "الباقة الملكية للعناية الكاملة (5 ساعات)",
            originalPrice: "699 ريال",
            discountPrice: "575 ريال",
            icon: "🌿",
            features: [
                "حلاقة شعر ودقن احترافية",
                "ساعة مساج استرخائي",
                "حمام مغربي عرسان (بخار + صابون + طين)",
                "تنظيف بشرة بالليزر وشفط دهون",
                "صنفرة وماسكات تفتيح البشرة",
                "بديكير كامل لليدين والأقدام",
                "منشفة باردة لشد الوجه"
            ]
        }
    ];

    return (
        <div id="team">
            <br />
            <h1 className='offers'>تعرف على عروضنا</h1>
            <p className='offersp'>استمتع بعروضنا الخاصة في مركز العناية بالرجال. نقدم جلسات مساج مميزة بأنواع متعددة مثل المساج التايلاندي والسويدي والاسترخائي. بالإضافة إلى حمام مغربي شامل بخدمات تنظيف وتقشير وترطيب البشرة. كما نوفر بديكير لليدين والأقدام يشمل تنظيف وترطيب وتقشير وعلاج مشاكل الجلد الجاف والتشققات. احصل على هذه العروض بأسعار تنافسية واستمتع بتجربة استرخاء فريدة</p>
            
            <div className="offers-container">
                {offers.map(offer => (
                    <div key={offer.id} className="offer-card">
                        <div className="offer-icon">{offer.icon}</div>
                        <h3 className="offer-title">{offer.title}</h3>
                        <p className="offer-description">{offer.description}</p>
                        <div className="offer-features">
                            {offer.features.map((feature, index) => (
                                <div key={index} className="offer-feature">
                                    <span className="feature-check">✓</span>
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>
                        <div className="offer-pricing">
                            <span className="original-price">{offer.originalPrice}</span>
                            <span className="discount-price">{offer.discountPrice}</span>
                        </div>
                        <button 
                            className="offer-button"
                            onClick={() => handleBookNow(offer.title)}
                        >
                            احجز الآن
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
